import React, { useMemo } from 'react';
import { Form, Input, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import map from 'lodash/map';
import ct from 'countries-and-timezones';
import reverse from 'lodash/reverse';
import sortBy from 'lodash/sortBy';
import SetupCard from './SetupCard';

const { Option } = Select;

const timezones = ct.getAllTimezones();

export default function SetupServer({
  initialValues,
  step,
  pending,
  onChange,
  onCancel,
  onDone,
}) {
  const [form] = Form.useForm();
  const { t } = useTranslation();

  const sortedTimezones = useMemo(
    () => reverse(sortBy(timezones, 'utcOffset')),
    [timezones]
  );

  const handleDone = () => {
    onDone(form.getFieldsValue());
  };

  return (
    <SetupCard
      step={step}
      pending={pending}
      onCancel={onCancel}
      onDone={handleDone}
    >
      <Form
        form={form}
        initialValues={initialValues}
        layout="vertical"
        name="setup-server-form"
        onValuesChange={onChange}
      >
        <Form.Item name="timezone" label={t('setup-server-timezone')}>
          <Select placeholder={t('select')} showSearch>
            {map(sortedTimezones, ({ name, utcOffsetStr }) => (
              <Option value={name}>{`${utcOffsetStr} ${name}`}</Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="url" label={t('setup-server-url')}>
          <Input autoComplete={false} />
        </Form.Item>
      </Form>
    </SetupCard>
  );
}
